import { string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Typography from 'ravenjs/lib/Typography';
import Box from 'ravenjs/lib/Box';
import Divider from 'ravenjs/lib/Divider';

import { AlertCircleOutline } from 'components/Icons';

const SidebarDisclaimerStyled = styled.div``;

const DisclaimerHeader = styled.div`
    display: flex;
    align-items: center;
    padding-left: 15px;
`;

const SidebarDisclaimer = ({ disclaimer }) => {
    return disclaimer ? (
        <SidebarDisclaimerStyled>
            <DisclaimerHeader>
                <AlertCircleOutline />
                <Typography type="disclaimer" gutterTop="2px" gutterBottom="0" gutterLeft="5px">
                    DISCLAIMER
                </Typography>
            </DisclaimerHeader>
            <Divider color="muted" gutterBottom="0" />
            <Box borderWidth="0" margin="0" padding="0 15px 20px">
                <Typography>{disclaimer}</Typography>
            </Box>
        </SidebarDisclaimerStyled>
    ) : null;
};

SidebarDisclaimer.propTypes = {
    disclaimer: string,
};

SidebarDisclaimer.defaultProps = {
    disclaimer: '',
};

export default SidebarDisclaimer;
